import { loadable } from '@elliemae/pui-app-sdk';

export const LoadableSchemaView = loadable(
  () =>
    import(
      /* webpackChunkName: "schema-view" */ /* webpackPrefetch: true */ './schemaView'
    ),
  null, // use wait message from html
);

export default LoadableSchemaView;
